var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return Object.keys(_vm.service).length !== 0
    ? _c(
        "div",
        { staticClass: "market-container" },
        [
          _c(
            "div",
            { staticClass: "header-background", style: _vm.headerImage },
            [
              _vm.serviceSummary.id === 10 &&
              _vm.planDetails &&
              !_vm.planDetails.serviceRenewed &&
              !_vm.serviceAdded &&
              _vm.todayDate() > _vm.renewStartDate() &&
              _vm.todayDate() < _vm.renewEndDate()
                ? _c("div", { staticClass: "offer-content" }, [
                    _c("img", {
                      staticClass: "rectanle-icon emergo-rec-blue",
                      attrs: {
                        src: "/static/images/icons/rectangle_banner_2.svg",
                      },
                    }),
                    _c("p", { staticClass: "free-text" }, [_vm._v("OFFER")]),
                  ])
                : _vm._e(),
              _vm.planDetails &&
              _vm.planDetails.serviceRenewed &&
              (_vm.serviceSummary.id == 1 ||
                _vm.serviceSummary.id == 2 ||
                _vm.serviceSummary.id == 4 ||
                _vm.serviceSummary.id == 10 ||
                _vm.serviceSummary.id == 6 ||
                _vm.serviceSummary.id == 7)
                ? _c("div", [_c("div", { staticClass: "ht-10" }), _vm._m(0)])
                : _vm._e(),
              _vm.planDetails &&
              !_vm.planDetails.serviceRenewed &&
              _vm.serviceAdded &&
              _vm.isProdClassServiceActive
                ? _c("div", [_c("div", { staticClass: "ht-10" }), _vm._m(1)])
                : _vm._e(),
              _c("div", { staticClass: "row heading p-20" }, [
                _c(
                  "span",
                  {
                    staticClass: "cursor-pointer",
                    on: { click: _vm.goToMarketPlace },
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-chevron-left",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _c("span", { staticClass: "pl-10" }, [
                      _vm._v("Marketplace"),
                    ]),
                  ]
                ),
              ]),
              _c("div", { staticClass: "row plb-25 ml-0 m-0" }, [
                _c(
                  "div",
                  { staticClass: "col-lg-7 col-md-9 col-sm-12 col-xs-12" },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-lg-2 col-md-2 col-sm-2 col-xs-3 p-0",
                        },
                        [
                          _vm.service.header.icon
                            ? _c("img", {
                                staticClass: "market-img",
                                attrs: {
                                  src:
                                    "/static/images/icons/" +
                                    _vm.service.header.icon,
                                  alt: "market-icon",
                                },
                              })
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-lg-10 col-md-10 col-sm-10 col-xs-9 p-0",
                        },
                        [
                          _c("div", { staticClass: "col-xs-12 pr-0 pl-0" }, [
                            _c("p", {
                              staticClass: "title text-color-white",
                              domProps: {
                                innerHTML: _vm._s(_vm.service.header.name),
                              },
                            }),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-lg-6 col-md-7 col-sm-6 col-xs-10 pr-0 pl-0",
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "sub-title font-less text-color-white",
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.service.header.data) + " "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]),
              _c("div", { staticClass: "row service-btn display-flex" }, [
                _vm.serviceSummary.id === 3 && _vm.service.header.demo_button
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-block watch-demo-btn emergo-blue-button float-right",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.goToVideoAndPlay(0, $event)
                          },
                        },
                      },
                      [
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(_vm.service.header.demo_button),
                          },
                        }),
                      ]
                    )
                  : _vm._e(),
                _vm.planDetails &&
                !_vm.planDetails.serviceRenewed &&
                !_vm.planDetails.serviceExpiry &&
                _vm.serviceAdded === false &&
                !_vm.trialEnded &&
                (_vm.serviceSummary.id === 1 ||
                  _vm.serviceSummary.id === 4 ||
                  _vm.serviceSummary.id === 6)
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn emergo-green-button btn-block side-btn",
                        class: { "service-added": _vm.serviceAdded },
                        attrs: { type: "button", disabled: _vm.notValidUser },
                        on: {
                          click: function ($event) {
                            return _vm.confirmSubscription(
                              _vm.planDetails.id,
                              "service"
                            )
                          },
                        },
                      },
                      [_c("span", [_vm._v(_vm._s(_vm.service.header.button))])]
                    )
                  : _vm._e(),
                _vm.planDetails &&
                !_vm.planDetails.serviceExpiry &&
                !_vm.planDetails.serviceRenewed &&
                !_vm.serviceAdded &&
                (_vm.serviceSummary.id === 7 || _vm.serviceSummary.id === 10)
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn emergo-green-button btn-block side-btn",
                        attrs: { type: "button", disabled: _vm.notValidUser },
                        on: { click: _vm.payForService },
                      },
                      [_vm._v(" Purchase ")]
                    )
                  : _vm._e(),
                _vm.planDetails &&
                ((_vm.serviceAdded && !_vm.showAdd) ||
                  (!_vm.serviceAdded && _vm.trialEnded)) &&
                !_vm.planDetails.serviceRenewed &&
                (_vm.serviceSummary.id === 4 || _vm.serviceSummary.id === 6)
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn emergo-green-button btn-block side-btn",
                        attrs: { type: "button", disabled: _vm.notValidUser },
                        on: {
                          click: function ($event) {
                            return _vm.payForService(false)
                          },
                        },
                      },
                      [_c("span", [_vm._v("Purchase")])]
                    )
                  : _vm._e(),
                _vm.planDetails &&
                !_vm.planDetails.serviceExpiry &&
                !_vm.planDetails.serviceRenewed &&
                !_vm.isDefaultMarket &&
                !_vm.allMarketsSelected &&
                _vm.serviceSummary.id === 2
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn emergo-green-button btn-block side-btn",
                        attrs: { type: "button", disabled: _vm.notValidUser },
                        on: { click: _vm.payForService },
                      },
                      [_c("span", [_vm._v("Purchase")])]
                    )
                  : _vm._e(),
                _vm.planDetails &&
                !_vm.planDetails.serviceExpiry &&
                !_vm.planDetails.serviceRenewed &&
                !_vm.isDefaultMarket &&
                !_vm.allMarketsSelected &&
                _vm.serviceSummary.id === 2
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-block side-btn emergo-blue-button one-free-button",
                        attrs: { type: "button", disabled: _vm.notValidUser },
                        on: { click: _vm.oneFreeMarket },
                      },
                      [_c("span", [_vm._v("Add One Free Market")])]
                    )
                  : _vm._e(),
                _vm.planDetails &&
                _vm.serviceSummary.id === 2 &&
                _vm.showAdd === "trial"
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn emergo-green-button btn-block side-btn",
                        attrs: { type: "button", disabled: _vm.notValidUser },
                        on: { click: _vm.payForService },
                      },
                      [_c("span", [_vm._v("Purchase")])]
                    )
                  : _vm._e(),
                _vm.planDetails &&
                _vm.serviceAdded &&
                !_vm.showAdd &&
                _vm.serviceSummary.id === 1
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn emergo-green-button btn-block side-btn",
                        attrs: { type: "button", disabled: _vm.notValidUser },
                        on: {
                          click: function ($event) {
                            return _vm.openPayModal()
                          },
                        },
                      },
                      [_c("span", [_vm._v("Purchase")])]
                    )
                  : _vm._e(),
                _vm.planDetails &&
                !_vm.planDetails.serviceExpiry &&
                !_vm.serviceAdded &&
                _vm.trialEnded &&
                !_vm.planDetails.serviceRenewed &&
                _vm.serviceSummary.id === 1
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn emergo-green-button btn-block side-btn",
                        attrs: { type: "button", disabled: _vm.notValidUser },
                        on: { click: _vm.payForService },
                      },
                      [_c("span", [_vm._v("Purchase")])]
                    )
                  : _vm._e(),
                _vm.planDetails &&
                !_vm.planDetails.serviceExpiry &&
                !_vm.planDetails.serviceRenewed &&
                _vm.serviceAdded &&
                _vm.showAdd &&
                _vm.serviceSummary.id === 1
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn emergo-green-button btn-block side-btn",
                        attrs: { type: "button", disabled: _vm.notValidUser },
                        on: {
                          click: function ($event) {
                            return _vm.openUpgradeModal()
                          },
                        },
                      },
                      [_c("span", [_vm._v("Upgrade service")])]
                    )
                  : _vm._e(),
                _vm.planDetails &&
                !_vm.planDetails.serviceExpiry &&
                !_vm.planDetails.serviceRenewed &&
                _vm.isDefaultMarket &&
                !_vm.allMarketsSelected &&
                _vm.serviceSummary.id === 2
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn emergo-green-button btn-block side-btn",
                        attrs: { type: "button", disabled: _vm.notValidUser },
                        on: { click: _vm.payForService },
                      },
                      [_c("span", [_vm._v("Upgrade service")])]
                    )
                  : _vm._e(),
                _vm.planDetails &&
                !_vm.planDetails.serviceExpiry &&
                !_vm.planDetails.serviceRenewed &&
                _vm.serviceAdded &&
                _vm.showAdd &&
                _vm.serviceSummary.id === 7 &&
                _vm.selectedPlan.id === 15
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn emergo-green-button btn-block side-btn",
                        attrs: {
                          type: "button",
                          disabled: _vm.notValidUser,
                          "data-toggle": "modal",
                          "data-target": "#regReportUpgradeModal",
                        },
                      },
                      [_c("span", [_vm._v("Upgrade service")])]
                    )
                  : _vm._e(),
                _vm.planDetails &&
                _vm.selectedPlan.id === 13 &&
                _vm.serviceAdded &&
                _vm.showAdd &&
                _vm.serviceSummary.id === 10 &&
                !_vm.planDetails.serviceExpiry &&
                !_vm.planDetails.serviceRenewed
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn emergo-green-button btn-block side-btn",
                        attrs: { type: "button", disabled: _vm.notValidUser },
                        on: { click: _vm.payForService },
                      },
                      [_c("span", [_vm._v("Upgrade service")])]
                    )
                  : _vm._e(),
                _vm.planDetails &&
                _vm.planDetails.serviceExpiry &&
                !_vm.planDetails.serviceRenewed &&
                _vm.showAdd &&
                (_vm.serviceSummary.id === 2 ||
                  _vm.serviceSummary.id === 1 ||
                  _vm.serviceSummary.id === 4 ||
                  _vm.serviceSummary.id === 6 ||
                  _vm.serviceSummary.id === 7 ||
                  _vm.serviceSummary.id === 10)
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn emergo-green-button btn-block side-btn",
                        attrs: { type: "button", disabled: _vm.notValidUser },
                        on: {
                          click: function ($event) {
                            return _vm.renewService(_vm.planDetails)
                          },
                        },
                      },
                      [_c("span", [_vm._v("Renew service")])]
                    )
                  : _vm._e(),
                _vm.serviceSummary.id === 3 ||
                _vm.serviceSummary.id === 5 ||
                _vm.serviceSummary.id === 8
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn emergo-green-button btn-block side-btn",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.openRequestPopup(_vm.serviceSummary.id)
                          },
                        },
                      },
                      [_c("span", [_vm._v(_vm._s(_vm.service.header.button))])]
                    )
                  : _vm._e(),
              ]),
            ]
          ),
          (_vm.serviceSummary.id == 3 || _vm.serviceSummary.id == 7) &&
          typeof _vm.service.smartbuilder !== "undefined"
            ? _c(
                "div",
                { staticClass: "row service_builder_desc" },
                [
                  _c("div", { staticClass: "row m-0" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-md-8 col-lg-8 col-sm-8 col-xs-12 ser_buil_head pd-lt-0",
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-xs-12" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "smart-builder-title text-color-blue",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.service.smartbuilder.header) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "row mr-bt-10" }, [
                          _c("div", { staticClass: "col-xs-12" }, [
                            _c("p", [
                              _vm._v(
                                _vm._s(_vm.service.smartbuilder.description)
                              ),
                            ]),
                          ]),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-4 col-lg-4 col-sm-4 col-xs-12" },
                      [
                        _c("div", {
                          staticClass:
                            "xs_ml_0 mr-lt-20 mt-5 mr-bt-10 desc-subheader text-color-blue cursor-pointer",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.service.smartbuilder.incountry_representation
                                .header
                            ),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.goToBlock("in-country-ref")
                            },
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._l(
                    _vm.service.smartbuilder.buttons,
                    function (eachChunk, chunkindex) {
                      return _c(
                        "div",
                        { key: chunkindex, staticClass: "row mt-10" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-xs-12 col-lg-12 pr-0 smart-builder display-flex",
                            },
                            _vm._l(eachChunk, function (block, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass:
                                    "col-md-4 col-sm-4 col-lg-4 col-xs-12 pl-0 xs_mb_15 display-flex",
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "col-md-4 col-sm-4 col-xs-3 col-lg-3 cursor-pointer tile_icon_wrapper p-0",
                                    style: {
                                      backgroundImage: `url(${_vm.returnFlag(
                                        block.country_code
                                      )})`,
                                    },
                                    on: {
                                      click: function ($event) {
                                        block.is_scroll
                                          ? _vm.goToBlock(
                                              block.show_block_id +
                                                "_smart_builder_block",
                                              block
                                            )
                                          : null
                                      },
                                    },
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-sm-8 col-xs-9 col-md-8 col-lg-9 cursor-pointer tile_desc_wrapper",
                                      on: {
                                        click: function ($event) {
                                          block.is_scroll
                                            ? _vm.goToBlock(
                                                block.show_block_id +
                                                  "_smart_builder_block",
                                                block
                                              )
                                            : null
                                        },
                                      },
                                    },
                                    [
                                      _c("div", {
                                        staticClass: "tile_desc",
                                        domProps: {
                                          innerHTML: _vm._s(block.header),
                                        },
                                      }),
                                      _c(
                                        "div",
                                        { staticClass: "country-template" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "country-name" },
                                            [_vm._v(_vm._s(block.country))]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      )
                    }
                  ),
                ],
                2
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "container-responsive" },
            [
              _vm.serviceSummary.id !== 3
                ? _c("div", { staticClass: "row m-30" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-offset-1 col-md-10 header-wrapper",
                      },
                      [
                        _c("p", {
                          staticClass: "desc-title text-color-blue",
                          domProps: {
                            innerHTML: _vm._s(_vm.service.description.data),
                          },
                        }),
                      ]
                    ),
                  ])
                : _vm._e(),
              _c(
                "div",
                { staticClass: "row m-30 button-box" },
                _vm._l(_vm.service.buttons, function (button, index) {
                  return _c(
                    "button",
                    {
                      key: index,
                      staticClass: "btn custom-btn",
                      on: {
                        click: function ($event) {
                          _vm.serviceSummary.id === 5 && index != 0
                            ? _vm.goToBlock(index + 1 + "_block")
                            : _vm.goToBlock(index + "_block")
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(button.name) + " ")]
                  )
                }),
                0
              ),
              _vm._l(_vm.blocks, function (block, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "row mtb-45-rl-30",
                    class: {
                      "block-display":
                        (block.imagedata &&
                          block.imagedata.imagetype == "default") ||
                        block.type !== "ggblock",
                      "bg-color-blue":
                        block.imagedata &&
                        block.imagedata.imagetype == "default" &&
                        block.background !== "white",
                    },
                    attrs: { id: index + "_block" },
                  },
                  [
                    block.type !== "ggblock"
                      ? [
                          !block.hideImage && block.imagedata
                            ? [
                                _c("image-block", {
                                  attrs: {
                                    imagedata: block.imagedata,
                                    laptopBlockHeight: _vm.laptopWrapper,
                                    sasToken: _vm.sasToken,
                                    alignment: block.content.align,
                                    serviceId: _vm.serviceId,
                                    paddingImage:
                                      block.request_button === true &&
                                      (_vm.serviceSummary.id === 5 ||
                                        _vm.serviceSummary.id === 8),
                                  },
                                }),
                              ]
                            : _vm._e(),
                          block.content
                            ? [
                                _c("content-block", {
                                  attrs: {
                                    content: block.content,
                                    sasToken: _vm.sasToken,
                                    design_type: block.imagedata.imagetype,
                                    alignment: block.content.align,
                                    button_name: _vm.service.header.button,
                                    button_valid: block.request_button
                                      ? block.request_button
                                      : false,
                                    colBlock:
                                      block.request_button === true &&
                                      (_vm.serviceSummary.id === 5 ||
                                        _vm.serviceSummary.id === 8),
                                  },
                                  on: {
                                    laptopblockheight: _vm.assignHeight,
                                    openRequest: function ($event) {
                                      return _vm.openRequestPopup(
                                        _vm.serviceSummary.id
                                      )
                                    },
                                  },
                                }),
                              ]
                            : _vm._e(),
                          block.content1
                            ? [
                                _c("content-block", {
                                  attrs: {
                                    content: block.content1,
                                    sasToken: _vm.sasToken,
                                    design_type: "default",
                                  },
                                  on: { laptopblockheight: _vm.assignHeight },
                                }),
                              ]
                            : _vm._e(),
                          block.content2
                            ? [
                                _c("content-block", {
                                  attrs: {
                                    content: block.content2,
                                    sasToken: _vm.sasToken,
                                    design_type: "default",
                                    alignment: block.content2.align,
                                  },
                                  on: { laptopblockheight: _vm.assignHeight },
                                }),
                              ]
                            : _vm._e(),
                        ]
                      : _vm._e(),
                    block.type === "ggblock"
                      ? [
                          _c("gg-template", {
                            attrs: { blocks: block, sasToken: _vm.sasToken },
                          }),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              }),
              _vm.serviceSummary.id == 3
                ? _c("smart-builder-template", {
                    attrs: {
                      blocksdata: _vm.service.smartbuilder,
                      id: _vm.serviceSummary.id,
                      header: _vm.service.header,
                    },
                    on: {
                      openRequestPopup: _vm.openRequestPopup,
                      goToVideoAndPlay: _vm.goToVideoAndPlay,
                    },
                  })
                : _vm._e(),
              _vm.serviceSummary.id == 6
                ? _c("product-classification-template", {
                    attrs: {
                      blocksdata: _vm.service.smartbuilder,
                      id: _vm.serviceSummary.id,
                      header: _vm.service.header,
                      notValidUser: _vm.notValidUser,
                    },
                  })
                : _vm._e(),
              _vm.serviceSummary.id == 3
                ? _c(
                    "div",
                    {
                      staticClass: "row m-30",
                      attrs: { id: "in-country-ref" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "col-md-6 col-sm-7 col-xs-12" },
                        [
                          _c("div", {
                            staticClass:
                              "col-md-12 col-sm-12 col-xs-12 desc-subheader pl-0 text-color-blue",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.service.smartbuilder
                                  .incountry_representation.block_header
                              ),
                            },
                          }),
                          _c("div", {
                            staticClass: "xs_mb_30",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.service.smartbuilder
                                  .incountry_representation.block_description
                              ),
                            },
                          }),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-md-offset-1 col-sm-5 col-xs-12 col-md-5 col-lg-4 incountry-block",
                        },
                        [
                          _c("div", {
                            staticClass: "xs_ml_0 mr-lt-20 mr-rt-20 mr-bt-10",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.service.smartbuilder
                                  .incountry_representation.header_description
                              ),
                            },
                          }),
                          _c(
                            "div",
                            {
                              staticClass: "xs_ml_0 mr-lt-20 mr-rt-20 mr-bt-10",
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.service.smartbuilder
                                        .incountry_representation.links_header
                                    ) +
                                    " "
                                ),
                              ]),
                              _vm._l(
                                _vm.service.smartbuilder
                                  .incountry_representation.links,
                                function (link, index) {
                                  return _c("div", { key: index }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "fz-14",
                                        attrs: {
                                          href: link.link,
                                          target: "_blank",
                                        },
                                      },
                                      [_vm._v(_vm._s(link.description))]
                                    ),
                                  ])
                                }
                              ),
                            ],
                            2
                          ),
                          _c(
                            "div",
                            { staticClass: "xs_ml_0 mr-rt-20 mr-lt-20" },
                            [
                              _c(
                                "b",
                                {
                                  staticClass: "cursor-pointer",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openRequestPopup(
                                        _vm.serviceSummary.id
                                      )
                                    },
                                  },
                                },
                                [_vm._v("Request a quote")]
                              ),
                              _vm._v(
                                " to get more information on your needs. "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              Object.keys(_vm.service.support).length !== 0
                ? _c("div", { staticClass: "row mtb-45-rl-30" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-md-12 bg-color-blue text-color-white p-15",
                      },
                      [
                        _c("div", {
                          staticClass: "desc-subheader",
                          domProps: {
                            innerHTML: _vm._s(_vm.service.support.header),
                          },
                        }),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(_vm.service.support.description),
                          },
                        }),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm.service.offer &&
              Object.keys(_vm.service.offer).length !== 0 &&
              _vm.serviceSummary.id !== 3 &&
              _vm.serviceSummary.id !== 5
                ? _c("div", { staticClass: "row mtb-45-rl-30" }, [
                    _c("div", { staticClass: "col-xs-12" }, [
                      _c("div", { staticClass: "row price-box" }, [
                        _vm.serviceSummary.id === 10 &&
                        _vm.todayDate() > _vm.renewStartDate() &&
                        _vm.todayDate() < _vm.renewEndDate()
                          ? _c("div", { staticClass: "offer-content" }, [
                              _c("img", {
                                staticClass:
                                  "rectanle-icon offer-intel emergo-rec-blue",
                                attrs: {
                                  src: "/static/images/icons/rectangle_banner_2.svg",
                                },
                              }),
                              _vm._m(2),
                            ])
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-lg-1 col-md-2 col-sm-2 col-xs-2 p-0",
                          },
                          [
                            _c("div", { staticClass: "img-card" }, [
                              _vm.service.header.icon
                                ? _c("img", {
                                    staticClass: "market-image",
                                    attrs: {
                                      src:
                                        "/static/images/icons/" +
                                        _vm.service.header.icon,
                                      alt: "market-icon",
                                    },
                                  })
                                : _vm._e(),
                            ]),
                          ]
                        ),
                        _vm.service.offer
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "col-lg-11 col-md-10 col-sm-10 col-xs-10",
                              },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-xs-12 col-sm-8 col-md-9 col-lg-9 p-xs-0",
                                    },
                                    [
                                      _vm.serviceSummary.id !== 1 &&
                                      _vm.serviceSummary.id !== 2 &&
                                      _vm.serviceSummary.id !== 4
                                        ? _c("p", {
                                            staticClass:
                                              "video-title text-color-blue font-bold ml-15",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.service.header.name
                                              ),
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.serviceSummary.id == 1 ||
                                      _vm.serviceSummary.id == 2 ||
                                      _vm.serviceSummary.id == 4
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "video-title text-color-blue font-bold ml-15",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.service.header.name
                                                  ) +
                                                  " * "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.service.offer.header &&
                                      !_vm.selectedPlan &&
                                      !_vm.trialEnded
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "video-title text-color-blue ml-15",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.service.offer.header
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c("span", [
                                        _vm.selectedPlan &&
                                        _vm.serviceAdded &&
                                        !_vm.isREP
                                          ? _c("p", { staticClass: "ml-15" }, [
                                              _vm._v(
                                                " until " +
                                                  _vm._s(
                                                    _vm._f("dateFormat")(
                                                      _vm.selectedPlan
                                                        .valid_until
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm.service.offer.description &&
                                        !_vm.selectedPlan &&
                                        !_vm.trialEnded
                                          ? _c("p", {
                                              staticClass: "ml-15",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.service.offer.description
                                                ),
                                              },
                                            })
                                          : _vm._e(),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-xs-10 col-sm-4 col-md-3 col-lg-3 price-btn align-right",
                                    },
                                    [
                                      _vm.planDetails &&
                                      !_vm.planDetails.serviceExpiry &&
                                      !_vm.serviceAdded &&
                                      !_vm.planDetails.serviceRenewed &&
                                      (_vm.serviceSummary.id === 7 ||
                                        _vm.serviceSummary.id === 10)
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn emergo-green-button btn-block side-btn",
                                              attrs: {
                                                type: "button",
                                                disabled: _vm.notValidUser,
                                              },
                                              on: { click: _vm.payForService },
                                            },
                                            [_c("span", [_vm._v("Purchase")])]
                                          )
                                        : _vm._e(),
                                      _vm.planDetails &&
                                      !_vm.planDetails.serviceExpiry &&
                                      _vm.serviceAdded === false &&
                                      !_vm.trialEnded &&
                                      !_vm.planDetails.serviceRenewed &&
                                      (_vm.serviceSummary.id === 1 ||
                                        _vm.serviceSummary.id === 4 ||
                                        _vm.serviceSummary.id === 6)
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn emergo-green-button btn-block side-btn",
                                              class: {
                                                "service-added":
                                                  _vm.serviceAdded,
                                              },
                                              attrs: {
                                                type: "button",
                                                disabled: _vm.notValidUser,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.confirmSubscription(
                                                    _vm.planDetails.id,
                                                    "service"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.service.offer.button
                                                  )
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.planDetails &&
                                      ((_vm.serviceAdded && !_vm.showAdd) ||
                                        (!_vm.serviceAdded &&
                                          _vm.trialEnded)) &&
                                      !_vm.planDetails.serviceRenewed &&
                                      (_vm.serviceSummary.id === 4 ||
                                        _vm.serviceSummary.id === 6)
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn emergo-green-button btn-block side-btn",
                                              attrs: {
                                                type: "button",
                                                disabled: _vm.notValidUser,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.payForService(
                                                    false
                                                  )
                                                },
                                              },
                                            },
                                            [_c("span", [_vm._v("Purchase")])]
                                          )
                                        : _vm._e(),
                                      _vm.planDetails &&
                                      !_vm.planDetails.serviceExpiry &&
                                      !_vm.planDetails.serviceRenewed &&
                                      !_vm.isDefaultMarket &&
                                      !_vm.allMarketsSelected &&
                                      _vm.serviceSummary.id === 2
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn emergo-green-button btn-block side-btn",
                                              attrs: {
                                                type: "button",
                                                disabled: _vm.notValidUser,
                                              },
                                              on: { click: _vm.payForService },
                                            },
                                            [_c("span", [_vm._v("Purchase")])]
                                          )
                                        : _vm._e(),
                                      _vm.planDetails &&
                                      _vm.serviceAdded &&
                                      !_vm.showAdd &&
                                      !_vm.planDetails.serviceRenewed &&
                                      _vm.serviceSummary.id === 1
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn emergo-green-button btn-block side-btn",
                                              attrs: {
                                                type: "button",
                                                disabled: _vm.notValidUser,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openPayModal()
                                                },
                                              },
                                            },
                                            [_c("span", [_vm._v("Purchase")])]
                                          )
                                        : _vm._e(),
                                      _vm.planDetails &&
                                      !_vm.planDetails.serviceExpiry &&
                                      !_vm.planDetails.serviceRenewed &&
                                      !_vm.serviceAdded &&
                                      _vm.trialEnded &&
                                      _vm.serviceSummary.id === 1
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn emergo-green-button btn-block side-btn",
                                              attrs: {
                                                type: "button",
                                                disabled: _vm.notValidUser,
                                              },
                                              on: { click: _vm.payForService },
                                            },
                                            [_c("span", [_vm._v("Purchase")])]
                                          )
                                        : _vm._e(),
                                      _vm.planDetails &&
                                      _vm.planDetails.serviceExpiry &&
                                      !_vm.planDetails.serviceRenewed &&
                                      _vm.showAdd &&
                                      (_vm.serviceSummary.id === 2 ||
                                        _vm.serviceSummary.id === 1 ||
                                        _vm.serviceSummary.id === 4 ||
                                        _vm.serviceSummary.id === 6 ||
                                        _vm.serviceSummary.id === 7 ||
                                        _vm.serviceSummary.id === 10)
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn emergo-green-button btn-block side-btn",
                                              attrs: {
                                                type: "button",
                                                disabled: _vm.notValidUser,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.renewService(
                                                    _vm.planDetails
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v("Renew service"),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.planDetails &&
                                      !_vm.planDetails.serviceExpiry &&
                                      !_vm.planDetails.serviceRenewed &&
                                      _vm.serviceAdded &&
                                      _vm.showAdd &&
                                      _vm.serviceSummary.id === 1
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn emergo-green-button btn-block side-btn",
                                              attrs: {
                                                type: "button",
                                                disabled: _vm.notValidUser,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openUpgradeModal()
                                                },
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v("Upgrade service"),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.planDetails &&
                                      _vm.selectedPlan.id === 13 &&
                                      _vm.serviceAdded &&
                                      _vm.showAdd &&
                                      _vm.serviceSummary.id === 10 &&
                                      !_vm.planDetails.serviceExpiry &&
                                      !_vm.planDetails.serviceRenewed
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn emergo-green-button btn-block side-btn",
                                              attrs: {
                                                type: "button",
                                                disabled: _vm.notValidUser,
                                              },
                                              on: { click: _vm.payForService },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v("Upgrade service"),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.planDetails &&
                                      !_vm.planDetails.serviceExpiry &&
                                      !_vm.planDetails.serviceRenewed &&
                                      _vm.serviceAdded &&
                                      _vm.showAdd &&
                                      _vm.serviceSummary.id === 7 &&
                                      _vm.selectedPlan.id === 15
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn emergo-green-button btn-block side-btn",
                                              attrs: {
                                                type: "button",
                                                disabled: _vm.notValidUser,
                                                "data-toggle": "modal",
                                                "data-target":
                                                  "#regReportUpgradeModal",
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v("Upgrade service"),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.planDetails &&
                                      !_vm.planDetails.serviceExpiry &&
                                      !_vm.planDetails.serviceRenewed &&
                                      _vm.isDefaultMarket &&
                                      !_vm.allMarketsSelected &&
                                      _vm.serviceSummary.id === 2
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn emergo-green-button btn-block side-btn",
                                              attrs: {
                                                type: "button",
                                                disabled: _vm.notValidUser,
                                              },
                                              on: { click: _vm.payForService },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v("Upgrade service"),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.planDetails &&
                                      !_vm.planDetails.serviceExpiry &&
                                      _vm.serviceSummary.id === 2 &&
                                      _vm.showAdd === "trial"
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn emergo-green-button btn-block side-btn",
                                              attrs: {
                                                type: "button",
                                                disabled: _vm.notValidUser,
                                              },
                                              on: { click: _vm.payForService },
                                            },
                                            [_c("span", [_vm._v("Purchase")])]
                                          )
                                        : _vm._e(),
                                      _vm.notValidUser
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "side-details fs-12",
                                            },
                                            [
                                              _vm._v(
                                                "Account Owners can add/upgrade service"
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]),
                                _c("div", {
                                  staticClass: "row market-line ml-15 mr-15",
                                }),
                                _c("div", { staticClass: "col-xs-12 p-xs-0" }, [
                                  _c("div", { staticClass: "col-xs-12" }, [
                                    !_vm.selectedPlan &&
                                    !_vm.trialEnded &&
                                    (_vm.serviceSummary.id === 1 ||
                                      _vm.serviceSummary.id === 4 ||
                                      _vm.serviceSummary.id === 6)
                                      ? _c("div", { staticClass: "row" }, [
                                          _c("p", [
                                            _vm._v(
                                              "Free trial availability for 30 days"
                                            ),
                                          ]),
                                        ])
                                      : _vm._e(),
                                    _c("div", [
                                      _vm.service.offer.plan
                                        ? _c(
                                            "div",
                                            { staticClass: "row" },
                                            [
                                              _c("div", {
                                                staticClass:
                                                  "font-bold m-0 service-package pb-10",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.service.offer.plan.name
                                                  ),
                                                },
                                              }),
                                              _vm._l(
                                                _vm.service.offer.plan.prices,
                                                function (plan, index) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: index,
                                                      staticClass: "col-xs-12",
                                                      class: {
                                                        "col-sm-12":
                                                          _vm.serviceSummary
                                                            .id != 7,
                                                        "col-sm-6":
                                                          _vm.serviceSummary
                                                            .id == 7,
                                                      },
                                                    },
                                                    [
                                                      _c("span", {
                                                        staticClass:
                                                          "list-item",
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            plan.value
                                                          ),
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                }
                                              ),
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                      _vm.service.offer.plan
                                        ? _c("div", {
                                            staticClass:
                                              "row market-line mt-20",
                                          })
                                        : _vm._e(),
                                      _vm.service.offer.bundle
                                        ? _c(
                                            "div",
                                            { staticClass: "row" },
                                            [
                                              _c("div", {
                                                staticClass:
                                                  "font-bold m-0 service-package pb-4",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.service.offer.bundle
                                                      .name
                                                  ),
                                                },
                                              }),
                                              _c("div", {
                                                staticClass:
                                                  "m-0 service-package-desc",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.service.offer.bundle
                                                      .desc
                                                  ),
                                                },
                                              }),
                                              _vm._l(
                                                _vm.service.offer.bundle.prices,
                                                function (plan2, ind) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: ind,
                                                      staticClass:
                                                        "col-xs-12 col-sm-6 col-md-6 col-lg-6 pt-20",
                                                    },
                                                    [
                                                      _c("span", {
                                                        staticClass:
                                                          "list-item",
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            plan2.value
                                                          ),
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                }
                                              ),
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                    ]),
                                  ]),
                                  _vm.service.offer.points
                                    ? _c("div", { staticClass: "col-xs-12" }, [
                                        _c("div", {
                                          staticClass: "row market-line mt-20",
                                        }),
                                        _vm.service.offer.points.name
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "row font-bold service-package pb-10",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.service.offer.points
                                                        .name
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "div",
                                          { staticClass: "row m-0" },
                                          [
                                            _vm._l(
                                              _vm.service.offer.points.value,
                                              function (point, index_V) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index_V,
                                                    staticClass:
                                                      "mb-15 col-xs-12 col-sm-12 col-md-12 p-0",
                                                  },
                                                  [
                                                    _c("span", {
                                                      staticClass: "list-item",
                                                      domProps: {
                                                        innerHTML:
                                                          _vm._s(point),
                                                      },
                                                    }),
                                                  ]
                                                )
                                              }
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "col-xs-12 p-0" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "list-item" },
                                                  [
                                                    _vm._v(
                                                      "Account includes 5 users. Click "
                                                    ),
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: "javascript:void(0)",
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.openAccountPopup,
                                                        },
                                                      },
                                                      [_vm._v("here")]
                                                    ),
                                                    _vm._v(
                                                      " for upgrade options."
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          2
                                        ),
                                      ])
                                    : _vm._e(),
                                ]),
                                (_vm.serviceSummary.id === 10 ||
                                  _vm.serviceSummary.id === 1 ||
                                  _vm.serviceSummary.id === 2 ||
                                  _vm.serviceSummary.id === 4 ||
                                  _vm.serviceSummary.id === 6 ||
                                  _vm.serviceSummary.id === 7) &&
                                _vm.todayDate() > _vm.renewStartDate() &&
                                _vm.todayDate() < _vm.renewEndDate()
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-sm-10 col-md-10 mr-tp-12 p-xs-0",
                                      },
                                      [_vm._m(3)]
                                    )
                                  : _vm._e(),
                                _vm.service.offer.note
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-sm-10 col-md-10 mr-tp-12 p-xs-0",
                                      },
                                      [
                                        _c("small", [
                                          _vm._v(
                                            _vm._s(_vm.service.offer.note)
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm.service.video
                ? _c(
                    "div",
                    {
                      staticClass: "video-background",
                      attrs: { id: "video-div" },
                    },
                    [
                      _vm.service.video && !Array.isArray(_vm.service.video)
                        ? _c("div", { staticClass: "row ptb-30 m-0" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-xs-offset-1 col-md-offset-2 col-xs-10 col-md-8",
                              },
                              [
                                _c("div", { staticClass: "row ptb-30" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-xs-12 video-title text-color-white",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.service.video.header) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("div", { staticClass: "row pt-10" }, [
                                  _vm.service.video.poster
                                    ? _c("div", { staticClass: "col-xs-12" }, [
                                        _c(
                                          "video",
                                          {
                                            staticClass:
                                              "video-js video-content",
                                            attrs: {
                                              id: "video_player_0",
                                              disablepictureinpicture: "",
                                              controls: "",
                                              controlslist: "nodownload",
                                              poster: _vm.getImageUrl(
                                                _vm.service.video.poster
                                              ),
                                            },
                                            on: {
                                              play: function ($event) {
                                                return _vm.videoPlayed(
                                                  _vm.service.video.header
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("source", {
                                              attrs: {
                                                src: _vm.videoUrl,
                                                type: "video/mp4",
                                              },
                                            }),
                                            _vm._v(
                                              " Your browser does not support HTML5 video. "
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _c("div", { staticClass: "col-xs-12" }, [
                                        _c(
                                          "video",
                                          {
                                            staticClass:
                                              "video-js video-content",
                                            attrs: {
                                              id: "video_player_0",
                                              disablepictureinpicture: "",
                                              controls: "",
                                              controlslist: "nodownload",
                                            },
                                            on: {
                                              play: function ($event) {
                                                return _vm.videoPlayed(
                                                  _vm.service.video.header
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("source", {
                                              attrs: {
                                                src: _vm.videoUrl,
                                                type: "video/mp4",
                                              },
                                            }),
                                            _vm._v(
                                              " Your browser does not support HTML5 video. "
                                            ),
                                          ]
                                        ),
                                      ]),
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "row video-text text-color-white ptb-30 pt-10",
                                  },
                                  [
                                    _c("div", { staticClass: "col-xs-8" }, [
                                      _vm._v(_vm._s(_vm.service.video.footer)),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "col-xs-4 align-right" },
                                      [_vm._v(_vm._s(_vm.videoLength))]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ])
                        : _c(
                            "div",
                            {
                              staticClass: "carousel slide mtb-30",
                              attrs: {
                                id: "VideoCarousel",
                                "data-ride": "carousel",
                                "data-interval": "false",
                                "data-wrap": "false",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "carousel-inner" },
                                _vm._l(
                                  _vm.service.video,
                                  function (video, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "item",
                                        class: { active: index == 0 },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "row ptb-30 m-0" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-xs-offset-1 col-md-offset-2 col-xs-10 col-md-8",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "row ptb-30" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-xs-12 video-title text-color-white",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.service.video[
                                                                index
                                                              ].header
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "row pt-10" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-xs-12",
                                                      },
                                                      [
                                                        _c(
                                                          "video",
                                                          {
                                                            staticClass:
                                                              "video-js video-content",
                                                            attrs: {
                                                              id:
                                                                "video_player_" +
                                                                index,
                                                              disablepictureinpicture:
                                                                "",
                                                              controls: "",
                                                              controlslist:
                                                                "nodownload",
                                                              poster:
                                                                _vm.videoPoster[
                                                                  index
                                                                ],
                                                            },
                                                            on: {
                                                              play: function (
                                                                $event
                                                              ) {
                                                                return _vm.videoPlayed(
                                                                  _vm.service
                                                                    .video[
                                                                    index
                                                                  ].header
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("source", {
                                                              attrs: {
                                                                src: _vm
                                                                  .videoUrl[
                                                                  index
                                                                ],
                                                                type: "video/mp4",
                                                              },
                                                            }),
                                                            _vm._v(
                                                              " Your browser does not support HTML5 video. "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "row video-text text-color-white ptb-30 pt-10",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "col-xs-8",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.service.video[
                                                                index
                                                              ].footer
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-xs-4 align-right",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.videoLength[
                                                                index
                                                              ]
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "left carousel-control",
                                  class: {
                                    "carousel-disable": _vm.carouselIndex === 0,
                                  },
                                  attrs: {
                                    "data-target": "#VideoCarousel",
                                    "data-slide": "prev",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.videoPause(_vm.carouselIndex)
                                    },
                                  },
                                },
                                [
                                  _c("span", {
                                    staticClass:
                                      "glyphicon glyphicon-chevron-left",
                                  }),
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v("Previous"),
                                  ]),
                                ]
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "right carousel-control",
                                  class: {
                                    "carousel-disable":
                                      _vm.carouselIndex ===
                                      _vm.service.video.length - 1,
                                  },
                                  attrs: {
                                    "data-target": "#VideoCarousel",
                                    "data-slide": "next",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.videoPause(_vm.carouselIndex)
                                    },
                                  },
                                },
                                [
                                  _c("span", {
                                    staticClass:
                                      "glyphicon glyphicon-chevron-right",
                                  }),
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v("Next"),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                    ]
                  )
                : _vm._e(),
              _vm.service.feedback &&
              Object.keys(_vm.service.feedback).length !== 0
                ? _c(
                    "div",
                    { staticClass: "row mtb-30 bg-light-blue plr-20" },
                    [
                      _c(
                        "div",
                        { staticClass: "col-md-offset-1 col-xs-12 col-md-10" },
                        [
                          _vm._m(4),
                          _c(
                            "div",
                            {
                              staticClass: "carousel slide mtb-30",
                              attrs: {
                                id: "myCarousel",
                                "data-ride": "carousel",
                                "data-interval": "10000",
                              },
                            },
                            [
                              _c(
                                "ol",
                                { staticClass: "carousel-indicators" },
                                [
                                  _vm._l(
                                    _vm.service.feedback,
                                    function (feeds, index) {
                                      return [
                                        _c("li", {
                                          key: index,
                                          class: { active: index == 0 },
                                          attrs: {
                                            "data-target": "#myCarousel",
                                            "data-slide-to": index,
                                          },
                                        }),
                                      ]
                                    }
                                  ),
                                ],
                                2
                              ),
                              _c(
                                "div",
                                { staticClass: "carousel-inner" },
                                _vm._l(
                                  _vm.service.feedback,
                                  function (feeds, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "item",
                                        class: { active: index == 0 },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "row pb-60" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-xs-offset-3 col-xs-5 col-sm-offset-0 col-sm-3 col-md-3 col-lg-2",
                                              },
                                              [
                                                _c("img", {
                                                  staticClass: "user-img pt-10",
                                                  attrs: {
                                                    src: _vm.getImageUrl(
                                                      feeds.image
                                                    ),
                                                    alt: "user-feed",
                                                  },
                                                }),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-xs-12 col-sm-9 col-md-9 col-lg-10",
                                              },
                                              [
                                                _c("p", {
                                                  staticClass:
                                                    "video-title text-color-black pt-10",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      feeds.data
                                                    ),
                                                  },
                                                }),
                                                _c("p", {
                                                  staticClass:
                                                    "sub-title pt-20",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      feeds.name
                                                    ),
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "modal fade",
              attrs: {
                id: "addModal",
                role: "dialog",
                "data-backdrop": "static",
              },
            },
            [
              _c(
                "div",
                { staticClass: "modal-dialog" },
                [
                  _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
                  _c("div", { staticClass: "modal-content" }, [
                    _c("div", { staticClass: "modal-header text-center" }, [
                      _vm._m(5),
                      _c("div", { staticClass: "row pt-10 add-modal-title" }, [
                        _vm._v("Service added to your account"),
                      ]),
                      _c("h4", { staticClass: "modal-title" }, [
                        _vm._v(_vm._s(_vm.serviceSummary.name)),
                      ]),
                    ]),
                    _vm.services.length > 0
                      ? _c(
                          "div",
                          { staticClass: "modal-body text-center" },
                          [
                            _c("p", { staticClass: "modal-body-heading" }, [
                              _vm._v("Complimentary Bundle"),
                            ]),
                            _c("p", { staticClass: "modal-body-sub-heading" }, [
                              _vm._v("Add other services now for free"),
                            ]),
                            _vm._l(_vm.services, function (other, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "row" },
                                [
                                  other.id === 1 || other.id === 4
                                    ? _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn emergo-blue-button custom-padding btn-modal-body",
                                          on: {
                                            click: function ($event) {
                                              return _vm.confirmSubscription(
                                                other.id,
                                                "other"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          other.id === 1
                                            ? _c("span", [
                                                _c("img", {
                                                  staticClass: "plus-icon",
                                                  attrs: {
                                                    src: "/static/images/icons/plus_icon.svg",
                                                    alt: "plus-icon",
                                                  },
                                                }),
                                                _vm._v(
                                                  " Add Registration Tracker "
                                                ),
                                              ])
                                            : _vm._e(),
                                          other.id === 4
                                            ? _c("span", [
                                                _c("img", {
                                                  staticClass: "plus-icon",
                                                  attrs: {
                                                    src: "/static/images/icons/plus_icon.svg",
                                                    alt: "plus-icon",
                                                  },
                                                }),
                                                _vm._v(
                                                  " Add Regulatory Watch "
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              )
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                    _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-link btn-bck-marketplace",
                          attrs: { type: "button", "data-dismiss": "modal" },
                          on: { click: _vm.goToMarketPlace },
                        },
                        [_vm._v(" Back to Marketplace ")]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-trck-plus emergo-green-button",
                          attrs: { type: "button", "data-dismiss": "modal" },
                          on: {
                            click: function ($event) {
                              return _vm.goToService(_vm.serviceSummary.id)
                            },
                          },
                        },
                        [
                          _vm._v(
                            " View " + _vm._s(_vm.serviceSummary.name) + " "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "modal fade",
              attrs: {
                id: "payModal",
                role: "dialog",
                "data-backdrop": "static",
              },
            },
            [
              _c(
                "div",
                { staticClass: "modal-dialog" },
                [
                  _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
                  _c("div", { staticClass: "modal-content" }, [
                    _c("div", { staticClass: "modal-header text-center" }, [
                      _c("div", { staticClass: "row pt-10 add-modal-title" }, [
                        _vm._v("Service requested"),
                      ]),
                      _c("h4", { staticClass: "modal-title fs-18" }, [
                        _vm._v(_vm._s(_vm.serviceSummary.name)),
                      ]),
                    ]),
                    _c("div", { staticClass: "modal-body text-center" }, [
                      _c("p", { staticClass: "modal-body-heading" }, [
                        _vm._v("Available Options"),
                      ]),
                      _c("p", { staticClass: "modal-body-sub-heading" }),
                      _c("div", { staticClass: "row" }, [
                        _c("h4", [_vm._v("Renew your trial account")]),
                        _c(
                          "button",
                          {
                            staticClass: "btn emergo-green-button fs-18",
                            on: {
                              click: function ($event) {
                                return _vm.payNow()
                              },
                            },
                          },
                          [_vm._v("Pay now")]
                        ),
                        _c("br"),
                        _c("h4", [
                          _vm._v(
                            "Upgrade your account for the duration of your trial"
                          ),
                        ]),
                        _c(
                          "button",
                          {
                            staticClass: "btn emergo-green-button fs-18",
                            on: {
                              click: function ($event) {
                                return _vm.openUpgradeModal("free")
                              },
                            },
                          },
                          [_vm._v(" Upgrade for Free ")]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-link btn-bck-marketplace",
                          attrs: { type: "button", "data-dismiss": "modal" },
                          on: { click: _vm.goToMarketPlace },
                        },
                        [_vm._v(" Back to Marketplace ")]
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ]
          ),
          _c("confirm-popup", { attrs: { planDetails: _vm.planDetails } }),
          _c("compliancewire-confirm-popup", {
            attrs: { planDetails: _vm.planDetails },
          }),
          _c("upgrade-modal", {
            attrs: {
              selectedService: _vm.selectedPlan,
              addonType: _vm.addonType,
              upgradeType: _vm.upgradeType,
            },
            on: { payForUpgradeService: _vm.payForUpgradeService },
          }),
          _vm.selectedPlan
            ? _c("reg-report-upgrade-modal", {
                attrs: { selectedService: _vm.selectedPlan },
                on: { payForUpgradeService: _vm.payForUpgradeService },
              })
            : _vm._e(),
          _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "market-service" }, [
      _c("img", {
        staticClass: "check-icon",
        attrs: {
          src: "/static/images/icons/circle_check.svg",
          alt: "check-icon",
        },
      }),
      _c("span", { staticClass: "service-active" }, [
        _vm._v("Service renewed"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "market-service" }, [
      _c("img", {
        staticClass: "check-icon",
        attrs: {
          src: "/static/images/icons/circle_check.svg",
          alt: "check-icon",
        },
      }),
      _c("span", { staticClass: "service-active" }, [_vm._v("Service active")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "free-text offer-intel-text" }, [
      _vm._v(" Offer on "),
      _c("br"),
      _vm._v(" Pro Plus "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("small", [
      _c("b", [
        _vm._v("Offer price on Pro Plus. Offer valid only until 09/31/2022"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row pt-20" }, [
      _c("div", { staticClass: "col-xs-12 user-title text-color-blue" }, [
        _vm._v("What did our users have to say?"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row display-flex" }, [
      _c("div", { staticStyle: { margin: "auto" } }, [
        _c("div", { staticClass: "modal-img" }, [
          _c("img", {
            staticClass: "check-img",
            attrs: {
              src: "/static/images/icons/check_icon.svg",
              alt: "check-icon",
            },
          }),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }